import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Button, ImageUploadWithPreview, TextField } from 'src/components';
import Loader from 'src/components/loader';
import { fetchSetting } from 'src/redux/action/setting.action';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

interface IProps {}

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Full Name must be a least 3 character long')
    .required('Full is required'),
  // tempAddress: Yup.string()
  //   .min(3, 'Temp Address must be a least 3 character long')
  //   .required('TempAddress is required'),
  image: Yup.string(),
});

const AboutTab: React.FC<IProps> = () => {
  const { settingData, loading, error } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );
  const [previewImage, setPreviewImage] = React.useState<any>(
    settingData?.businessInfo?.logo
  );
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const onEditorStateChange = (state: EditorState) => {
    setEditorState(state);
  };

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (settingData?.businessInfo?.length > 0) return;
    dispatch(fetchSetting() as any);
  }, [dispatch]);

  const initValues = {
    services: settingData?.businessInfo?.services,
  };

  const handleSubmitBusiness = async (values: any) => {
    const payload = {
      name: values?.name,
      logo: values?.image,
    };
    try {
      await Service.post('/businesses/info/update', payload);
      toastAlert('success', `Business ${values?.name} is successfully created`);
      dispatch(fetchSetting() as any);
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <div>
      {loading ? (
        <Loader className="settings" />
      ) : (
        <Formik
          initialValues={initValues}
          validateOnMount
          validationSchema={FORM_VALIDATION}
          onSubmit={handleSubmitBusiness}
        >
          {({ isValid, isSubmitting, setFieldValue }) => (
            <Form>
              <div className="relative">
                <span className="text-base font-semibold">
                  General Information
                </span>
                <div className="z-90 mb-5 mt-4">
                  <TextField
                    label={'Name'}
                    name="name"
                    defaultValue={
                      settingData ? settingData?.businessInfo?.name : ''
                    }
                  />
                  <ImageUploadWithPreview
                    label="Logo"
                    previewImage={previewImage}
                    setPreviewImage={setPreviewImage}
                    setFieldValue={setFieldValue}
                  />
                </div>
                <Editor
                  editorState={editorState}
                  toolbarClassName="toolbarClassName border-solid border-border-color-dark rounded-xl"
                  wrapperClassName="wrapperClassName border-solid border-border-color-dark"
                  editorClassName="editorClassName min-h-20 h-auto border border-solid border-border-color-dark rounded-xl px-4"
                  onEditorStateChange={onEditorStateChange}
                />
              </div>
              <div className="flex items-center justify-end mt-6">
                <Button
                  text="save Details"
                  variant="primary"
                  type="submit"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </div>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default React.memo(AboutTab);
